<template>
	<div class="orderdetail">
		<!-- 退款原因框 -->
		<el-dialog title="退款原因" :visible.sync="reason_model" :before-close="close_refund" :close-on-click-modal='true'
			width="800px" top="10vh">
			<div class="order-detail-dialog">
				<div class="reason-imgview">
					<div class="imgview">
						<img class="imgbig" :src="imgs[imgindex]" />
					</div>
					<div class="imgsview">
						<template v-for="(item,index) in imgs">
							<div @click="changeimg(index)" :class="index == imgindex?'imgcheck imgone':'imgone'">
								<img :src="item" />
							</div>
						</template>
					</div>
				</div>
				<div class="reason-txt" v-if="reason_txt!=''">
					{{reason_txt}}
				</div>
			</div>
		</el-dialog>
		<div class="nav_cont">
			<div class="fh" @click="go_router"><i class="el-icon-arrow-left" style="margin-right: 12px;"></i>返回</div>
			<div class="fabu">订单详情</div>
		</div>

		<el-row :gutter="16">
			<el-col :span="8">
				<div class="white">
					<div class="head-title"><span class="tit-mar">基础信息</span></div>
					<div style="padding: 10px 0;">
						<div class="parameter">
							<div class="parameter_tit">订货状态:</div>
							<div class="parameter_val_status">
								{{baseinfo.status_text}}
							</div>
						</div>

						<div class="parameter">
							<div class="parameter_tit">订单编号:</div>
							<div class="parameter_val">
								{{baseinfo.order_sn}}
							</div>
						</div>

						<div class="parameter">
							<template v-if="baseinfo.type == 8">
								<div class="parameter_tit">来自活动:</div>
								<div class="parameter_val" @click="goActivity(baseinfo.delivery_type,baseinfo.activity_id)" style="color: #409EFF;cursor: pointer;">{{baseinfo.activity_name}} ></div>
							</template>
							<template v-else>
								<div class="parameter_tit">所属合伙人:</div>
								<div class="parameter_val">
									{{baseinfo.partner_name}}
								</div>
							</template>
						</div>

						<div class="parameter">
							<div class="parameter_tit">所在社群:</div>
							<div class="parameter_val">
								{{baseinfo.group_name}}
							</div>
						</div>

						<div class="parameter">
							<div class="parameter_tit">实付金额:</div>
							<div class="parameter_val redFF1300">
								￥{{baseinfo.order_amount}}
							</div>
						</div>

						<div class="parameter">
							<div class="parameter_tit">下单时间:</div>
							<div class="parameter_val">
								{{baseinfo.add_time}}
							</div>
						</div>

						<div class="parameter" v-if="baseinfo.order_status != 0 && baseinfo.order_status != -2">
							<div class="parameter_tit">支付时间:</div>
							<div class="parameter_val">
								{{baseinfo.pay_time}}
							</div>
						</div>
					</div>

				</div>
			</el-col>
			<el-col :span="8">
				<div class="white">
					<div class="head-title" v-if="baseinfo.delivery_type == 3">
						<span class="tit-mar">提货人</span>
						<span class="hx_btn" v-if="baseinfo.order_status == 1" @click="openSettlement">核销完成</span>
					</div>
					<div class="head-title" v-else>
						<span class="tit-mar">收货人信息</span>
					</div>
					
					<div style="padding: 10px 0;">
						<div class="parameter">
							<div class="parameter_tit" v-if="baseinfo.delivery_type == 3">提货人:</div>
							<div class="parameter_tit" v-else>收货姓名:</div>
							<div class="parameter_val">
								{{addressinfo.name}}
							</div>
						</div>


						<div class="parameter">
							<div class="parameter_tit" v-if="baseinfo.delivery_type == 3">提货电话:</div>
							<div class="parameter_tit" v-else>收货电话:</div>
							<div class="parameter_val">
								{{addressinfo.phone}}
							</div>
						</div>

						<div class="parameter" v-if="baseinfo.delivery_type == 1 || baseinfo.delivery_type == 2">
							<div class="parameter_tit">收货地址:</div>
							<div class="parameter_val">
								{{addressinfo.address_str}}
							</div>
						</div>


						<div class="parameter">
							<div class="parameter_tit">用户备注:</div>
							<div class="parameter_val" style="color: #409EFF;height: 118px;overflow: auto;">
								{{baseinfo.user_note}}
							</div>
						</div>

					</div>
				</div>
			</el-col>
			
			
			<!-- 自提点信息 -->
			<el-col :span="8" v-if="baseinfo.delivery_type == 3" style="position: relative;">
				<div class="white">
					<div class="head-title">
						<span class="tit-mar">自提点信息</span>
					</div>
					
					<!-- 自提点头图 -->
					<input v-if="point.cover != ''" class="pcover point_cover" type="image" :src="point.cover" />
					<div v-else class="pcover point_font">{{point.name.substring(0,4)}}</div>
			
					<div class="parameter">
						<div class="parameter_tit">自提点:</div>
						<div class="parameter_val" style="width: 60%;">
							{{point.name}}
						</div>
					</div>
					
					<div class="parameter">
						<div class="parameter_tit">联系人:</div>
						<div class="parameter_val">
							{{point.linkman == '' ? '未设置联系人' : point.linkman}}
						</div>
					</div>
					
					<div class="parameter">
						<div class="parameter_tit">电话:</div>
						<div class="parameter_val">
							{{point.phone}}
						</div>
					</div>
					
					<div class="parameter">
						<div class="parameter_tit">位置:</div>
						<div class="parameter_val">
							{{point.province}}/{{point.city}}/{{point.county}}
						</div>
					</div>
					
					<div class="parameter">
						<div class="parameter_tit">详细地址:</div>
						<div class="parameter_val">
							{{point.address}}
						</div>
					</div>
				
				</div>
			</el-col>
			
			<!-- 物流信息 -->
			<el-col :span="8" v-else>
				<div class="white">
					<div class="head-title">
						<span class="tit-mar">物流信息</span>

						<span v-if="package_num > 0"
							style="cursor: pointer;float:right;font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;margin-right: 16px;">
							<a href="https://www.kuaidi100.com/"
								style="color: #409EFF;text-decoration: none;">查询详细物流</a>
						</span>
					</div>

					<div style="padding: 10px 0;" v-if="package_num > 0">
						<div class="parameter">
							<div class="parameter_tit">物流包裹:</div>
							<div class="parameter_val">
								{{package_num}}个
								<div v-if="package_num>2"
									style="color: #409EFF;float: right;margin-right: 16px;cursor: pointer;"
									@click="dialogTableVisible = true">全部包裹</div>
							</div>
						</div>
					</div>


					<div v-if="package_num > 0">
						<div class="order_list">
							<el-row v-for="item in packages.slice(0,2)">
								<!-- 	<el-col :span="3" >
									<div class="one_zi">
											{{item.ems_name.charAt(0)}}
									</div>
								</el-col> -->
								<el-col :span="24" style="display: flex;margin-bottom: 20px;">
									<div class="one_zi">
										{{item.ems_name.charAt(0)}}
									</div>
									<div style="width: 75%;">
										<el-row style="margin-bottom: 0;">
										 <el-col :span="24">
												<div class="order_code">{{item.ems_name}} <span
														style="margin-left: 5px;">{{item.ems_code}}</span></div>
											</el-col>
											<el-col :span="24">
												<div class="order_code chaochu"
													style="margin-top: 9px;color: #999999;font-size: 12px;">
													{{item.ems_name == '同城配送' && item.context == '订单物流信息尚未更新，请稍后进行查看' && !item.ems_code?'商家同城配送中':item.context}}

												</div>

											</el-col>

										</el-row>
									</div>
									<div style="margin-left: auto;margin-right: 20px;">
										<i class="el-icon-edit" style="color: #39AEFF;cursor: pointer;"
											v-if="baseinfo.order_status == 2" @click="edit_packages(item.id)"></i>
									</div>
								</el-col>
								<!-- <el-col :span="2">
									<i class="el-icon-edit" style="color: #39AEFF;cursor: pointer;" v-if="baseinfo.order_status == 2" @click="edit_packages(item.id)"></i>
								</el-col> -->
							</el-row>
						</div>

						<div class="zjbg" @click="show_parcel = true" v-if="baseinfo.order_status == 2">追加包裹</div>
					</div>

					<div v-if="package_num == 0" style="text-align: center;margin-top: 45px;">
						<img class="wuliu_null" src="../../assets/img/order/wuliu.png" />
						<p
							style="color: #999999;font-size: 12px;text-align: center;margin-top: 10px;margin-bottom: 17px;">
							{{baseinfo.order_status == 1 ?'还没发货哦':'当前订单无物流信息'}}

						</p>

						<div class="fahuo" @click="show_parcel=true" v-if="baseinfo.order_status == 1">发货</div>
					</div>


				</div>
			</el-col>
		</el-row>


		<el-dialog width="567px" :title='"全部包裹("+packages.length+")"' :visible.sync="dialogTableVisible">
			<el-table :data="packages" :show-header="false" id="all_baoguo">
		 	<el-table-column>
					<template slot-scope="scope">
						<el-row>
					 	<el-col :span="21">
								<div class="hhrtx">
									<div class="one_zi">
										{{scope.row.ems_name.charAt(0)}}
									</div>
									<div class="hhrname">
										<p
											style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #333333;">
											{{scope.row.ems_name}} <span
												style="margin-left: 5px;">{{scope.row.ems_code}}</span></p>
										<p
											style="font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #999999;">
											{{scope.row.ems_name == '同城配送' && scope.row.context == '订单物流信息尚未更新，请稍后进行查看' && !scope.row.ems_code ?'商家同城配送中':scope.row.context}}
										</p>
									</div>
								</div>

							</el-col>
					 	<el-col :span="3">
						 	<i class="el-icon-edit" v-if="baseinfo.order_status == 2"
									style="color: #409EFF;margin-right: 6px;"></i>
								<span style="color: #409EFF;font-size: 14px;cursor: pointer;"
									v-if="baseinfo.order_status == 2" @click="edit_packages(scope.row.id)">更改</span>
							</el-col>
						</el-row>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>

		<!-- 表格 -->
		<el-table v-loading="loading" :data="order_product" style="width: 100%;margin-top:16px;">
			<el-table-column label="商品信息" width="300" align="left">
				<template slot-scope="scope">
					<div class="hhrtx">
						<div style="width: 50px;height: 50px;">
							<div class="hhrimg2">
								<img :src='scope.row.cover_url' class="hhrimg" />
								<p class="ytk" v-if="scope.row.is_refund == 2">已退款</p>
								<p class="tkz" v-if="scope.row.is_refund == 1">退款中</p>
							</div>
						</div>
						<div class="hhrname">
							<!-- 	<p style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;
								color: #333333;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 2; 
								-webkit-box-orient: vertical; overflow: hidden;word-break: break-all;">{{scope.row.product_name}}</p> -->

							<el-tooltip placement="top" v-model="scope.row.showTooltip" :open-delay="500" effect="dark"
								:disabled="!scope.row.showTooltip">
								<div slot="content">{{scope.row.product_name}}</div>
								<div @mouseenter="showTips($event,scope.row)" style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;
								  color: #333333;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 2; 
								-webkit-box-orient: vertical; overflow: hidden;word-break: break-all;">{{scope.row.product_name}}</div>
							</el-tooltip>
							<p
								style="font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #999999;">
								{{scope.row.pay_sku}}</p>
						</div>
					</div>

				</template>
		 </el-table-column>
			<el-table-column prop="price" label="单价" align="center">
				<template slot-scope="scope">
					<span
						style="font-size: 14px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #330000;">￥{{scope.row.price}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="product_num" label="数量" align="center">
				<template slot-scope="scope">
					×{{scope.row.product_num}}
				</template>
			</el-table-column>
			<el-table-column prop="sales_product" label="佣金率" align="center">
				<template slot-scope="scope">
					{{scope.row.commission_rate}}%
				</template>
			</el-table-column>
			<el-table-column prop="commission" label="支出佣金" align="center">
				<template slot-scope="scope">
					<span class="redFF1300">￥{{scope.row.commission}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="service_rate" label="服务费率" align="center">
				<template slot-scope="scope">
					{{scope.row.service_rate}}%
				</template>
			</el-table-column>
			<el-table-column prop="service_fee" label="服务费" align="center">
				<template slot-scope="scope">
					￥{{scope.row.service_fee}}
				</template>
			</el-table-column>
			<el-table-column prop="is_refund" label="退款状态" align="center">
				<template slot-scope="scope">
					<template v-if="scope.row.is_refund == 1">
						退款中
					</template>
					<template v-else-if="scope.row.is_refund == 2">
						退款完成
					</template>
					<template v-else>
						--
					</template>
				</template>
			</el-table-column>
			<el-table-column prop="refund_desc" width="150" label="退款原因" align="center">
				<template slot-scope="scope">
					<div @click="showReasonModel(scope.row.imgs,scope.row.refund_desc)" class="reason-table-view"
						v-if="scope.row.imgs.length>0" style="display: flex;align-items: center;">
						<div class="reason-img-one"><img class="reason-img-one-img" :src="scope.row.imgs[0]" alt=""
								style="height: 40px;width: 40px;" /></div>
						<div class="look-reason">查看原因</div>
					</div>
					<el-tooltip v-else placement="top" v-model="scope.row.showReasontip" :open-delay="500"
						effect="dark">
						<div slot="content">{{scope.row.refund_desc?scope.row.refund_desc:'--'}}</div>
						<div @mouseenter="showReasonTips($event,scope.row)" style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;
					  color: #333333;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 2; 
					-webkit-box-orient: vertical; overflow: hidden;word-break: break-all;">
							{{scope.row.refund_desc?scope.row.refund_desc:'--'}}</div>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="佣金状态" align="center">
				<template slot-scope="scope">
					<span v-if="baseinfo.order_status == 0 || baseinfo.order_status == -2">
						--
					</span>
					<span v-if="baseinfo.order_status != 0 && baseinfo.order_status != -2">
						{{ scope.row.status == 1?'已支出':scope.row.status==2?'已失效':'未支出'}}
					</span>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页器 -->
		<div class="block" style="padding: 40px;background: #ffffff;">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
				layout="total, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

		<parcel v-if="show_parcel" :show_parcel.sync="show_parcel" :order_sn='order_sn' :op_id='op_id'></parcel>
		
		<settlement :order_sn="baseinfo.order_sn" :show="show_settlement"  @close="closeSettlement" @success="SettlementSuccess"></settlement>
	</div>
</template>

<script>
	import {
		getOrderDetail
	} from '../../api/order';
	import parcel from '@/components/parcel.vue';
	import settlement from '@/components/order/settlement.vue';
	export default {
		data() {
			return {
				baseinfo: [], //基础信息
				addressinfo: [], //收货人信息
				packages: [], //物流信息
				package_num: 0,
				loading: true,
				order_sn: '',
				order_product: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				pageSize: 10, // 每页的数据条数
				loading: true,
				dialogTableVisible: false, //全部包裹弹窗
				gridData: [],
				show_parcel: false,
				op_id: 0, //快递id
				list_page: 1,
				reason_model: false,
				imgs: [],
				imgindex: 0,
				reason_txt: '',
				point: [],
				show_settlement: false
			};
		},
		components: {
			parcel,
			settlement
		},
		destroyed() {
			window.removeEventListener('popstate', this.goBack, false);
		},
		watch: {
			show_parcel: function(val, oldVal) {
				if (!val) {
					this.op_id = 0;
				}
				this.getDetail();
			}
		},
		mounted() {
			let query = this.$route.query;
			var that = this;
			if (query.order_sn) {
				that.order_sn = query.order_sn;
			}
			if (query.list_page) {
				that.list_page = query.list_page;
			}
			this.getDetail();

			//监听浏览器返回
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.goBack, false);
			}
		},
		methods: {
			goActivity(type,id) {
				if(type == 1){
					this.$router.push({
						path: '/promotion/interest-data',
						query: {
							event_id: id
						}
					});
				}else{
					this.$router.push({
						path: '/promotion/local-data',
						query: {
							event_id: id
						}
					});
				}
			},
			showReasonModel(imgs, reason) {
				this.reason_model = true;
				this.reason_txt = reason;
				this.imgs = imgs;
				this.imgindex = 0;
			},
			changeimg(index) {
				this.imgindex = index;
			},
			close_refund() {
				this.reason_model = false;
				this.reason_txt = '';
				this.imgs = [];
				this.imgindex = 0;
			},
			showReasonTips(obj, row) {
				/*obj为鼠标移入时的事件对象*/

				/*width为文本在页面中所占的宽度，创建标签，加入到页面，获取width,最后在移除*/
			 let TemporaryTag = document.createElement('span');
				TemporaryTag.innerText = row.refund_desc;
				TemporaryTag.className = 'getTextWidthReason';
				document.querySelector('body').appendChild(TemporaryTag);
			 let currentWidth = document.querySelector('.getTextWidthReason').offsetWidth;
				document.querySelector('.getTextWidthReason').remove();

				/*cellWidth为表格容器的宽度*/
				const cellWidth = obj.target.offsetWidth

				/*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
				currentWidth <= (2 * cellWidth) ? row.showReasontip = false : row.showReasontip = true,
					console.log(row.showReasontip);
			},
			getDetail() {
				getOrderDetail({
					'order_sn': this.order_sn,
				}).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.baseinfo = res.data.base;
						this.addressinfo = res.data.address;
						this.total = res.data.order_product.length;
						this.order_product = res.data.order_product;
						this.packages = res.data.packages;
						this.package_num = res.data.package_num;
						this.point = res.data.point;
					} else {
						this.$message.error(res.message);
					}

				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
			},
			edit_packages(val) {
				this.op_id = val;
				this.show_parcel = true;
			},
			go_router() {
				localStorage.setItem('keypage', this.list_page);
				this.$router.go(-1)
			},
			goBack() {
				// console.log("点击了浏览器的返回按钮");
				localStorage.setItem('keypage', this.list_page);
				this.$router.go(-1);
			},
			showTips(obj, row) {
				/*obj为鼠标移入时的事件对象*/

				/*width为文本在页面中所占的宽度，创建标签，加入到页面，获取width,最后在移除*/
				let TemporaryTag = document.createElement('span');
				TemporaryTag.innerText = row.product_name;
				TemporaryTag.className = 'getTextWidth';
				document.querySelector('body').appendChild(TemporaryTag);
				let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
				document.querySelector('.getTextWidth').remove();

				/*cellWidth为表格容器的宽度*/
				const cellWidth = obj.target.offsetWidth

				/*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
				currentWidth <= (2 * cellWidth) ? row.showTooltip = false : row.showTooltip = true
			},
			
			// 核销完成
			openSettlement(){
				this.show_settlement = true;
			},
			closeSettlement(){
				this.show_settlement = false;
			},
			SettlementSuccess(){
				this.baseinfo.order_status = 4;
				this.baseinfo.status_text = '已完成';
				this.closeSettlement();
			}
		}
	};
</script>

<style scoped>
	.father-main {
		overflow: auto;
	}

	.el-table__body {
		/* // 使表格兼容safari，不错位 */
		width: 100%;
		table-layout: fixed !important;
	}

	.orderdetail .nav_cont {
		width: 100%;
		height: 30px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		margin-bottom: 15px;
	}

	.formtit {
		width: 100px;
		height: 25px;
		border-left: 3px solid #409EFF;
		line-height: 25px;
		padding-left: 15px;
		margin-bottom: 23px;
	}

	.fh {
		width: 80px;
		height: 23px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 23px;
		border-right: 1px solid #CCCCCC;
		margin-right: 21px;
		cursor: pointer;
	}

	.fabu {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}

	.white {
		min-height: 330px;
		background-color: #FFFFFF;
		border-radius: 4px;
	}

	.head-title {
		width: 100%;
		height: 50px;
		line-height: 50px;
		border-bottom: 1px solid #EEEEEE;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}

	.tit-mar {
		padding-left: 15px;
	}

	.parameter {
		display: flex;
		/* align-items: center; */
		/* height: 34px; */
		margin: 15px 0;
		margin-left: 15px;

	}

	.parameter_tit {
		width: 78px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
	}

	.parameter_val_status {
		height: 19px;
		background-color: rgba(64, 158, 255, 0.1);
		border-radius: 2px;
		font-size: 14px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #409EFF;
		line-height: 19px;
		text-align: center;
		padding: 2px 10px;
	}

	.parameter_val {
		width: 80%;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}

	.redFF1300 {
		color: #FF1300;
	}

	.el-table th {
		text-align: center;
	}

	.order_list {
		padding-bottom: 5px;
	}

	.orderdetail .order_status {
		text-align: right;
		padding-right: 10px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		line-height: 60px;
	}

	.orderdetail .order_code {
		height: 20px;
		font-size: 14px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		color: #333333;
		padding-left: 10px;
		margin: 0;
	}

	.orderdetail .hhr_nc {
		height: 20px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
	}

	.zjbg {
		width: 95px;
		height: 40px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #606266;
		text-align: center;
		line-height: 40px;
		margin: 0 auto;
		cursor: pointer;
	}

	.hhrimg {
		width: 50px;
		height: 50px;
		border-radius: 2px;
	}

	.hhrimg2 {
		width: 50px;
		height: 50px;
		border-radius: 2px;
		position: relative;
	}

	.ytk {
		position: absolute;
		bottom: 0;
		width: 50px;
		height: 16px;
		line-height: 16px;
		color: #FFFFFF;
		background-color: #CCCCCC;
		text-align: center;
		border-bottom-right-radius: 2px;
		border-bottom-left-radius: 2px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
	}

	.tkz {
		position: absolute;
		bottom: 0;
		width: 50px;
		height: 16px;
		line-height: 16px;
		color: #FFFFFF;
		background-color: #FF8700;
		text-align: center;
		border-bottom-right-radius: 2px;
		border-bottom-left-radius: 2px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
	}

	.hhrname {
		width: 85%;
		margin-left: 16px;
	}

	#all_baoguo {
		height: 300px;
		overflow: auto;
	}

	.orderdetail .hhrtx {
		display: flex;
		align-items: center;
	}

	.orderdetail .el-dialog__body {
		padding: 0;
	}

	.orderdetail .el-table--border::after,
	.el-table--group::after,
	.el-table::before {
		background: none;
	}

	.wuliu_null {
		width: 128px;
		height: 75px;
	}

	.fahuo {
		width: 102px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		margin: 0 auto;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		cursor: pointer;
	}

	.orderdetail .chaochu {
		width: 100%;
		/*根据自己项目进行定义宽度*/
		overflow: hidden;
		/*设置超出的部分进行影藏*/
		text-overflow: ellipsis;
		/*设置超出部分使用省略号*/
		white-space: nowrap;
		/*设置为单行*/
	}

	.one_zi {
		width: 40px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background-color: #FF8700;
		font-size: 18px;
		border-radius: 2px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #FFFFFF;
		margin-left: 15px;
	}

	.myNote {
		display: -webkit-box;
		text-overflow: ellipsis;
		overflow: hidden;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.el-tooltip__popper {
		max-width: 20%;
	}

	.el-tooltip__popper,
	.el-tooltip__popper.is-dark {
		background: rgb(48, 65, 86) !important;
		color: #fff !important;
		line-height: 24px;
	}

	/* 退款原因及弹框 */
	.reason-table-view .reason-img-one {
		width: 40px;
		height: 40px;
	}

	.reason-img-one-img {
		cursor: pointer;
		width: 40px;
		height: 40px;
		border-radius: 2px;
		object-fit: cover;
	}

	.look-reason {
		cursor: pointer;
		width: 60px;
		margin-left: 10px;
		text-decoration: underline;
		font-size: 14px;
		font-weight: 500;
		color: #333333;
	}

	.order-detail-dialog .reason-imgview {
		padding-bottom: 12px;
		display: flex;
	}

	.order-detail-dialog .imgview {
		width: 587px;
		height: 418px;
		background: #F2F6FC;
		margin-right: 64px;
		margin-left: 20px;
	}

	.order-detail-dialog .imgbig {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.order-detail-dialog .imgone {
		width: 70px;
		height: 70px;
		margin-bottom: 12px;
		cursor: pointer;
		border: #ffffff 2px solid;
	}

	.order-detail-dialog .imgone img {
		display: block;
		width: 70px;
		height: 70px;
		object-fit: cover;
	}

	.order-detail-dialog .imgcheck {
		border: #FEC418 2px solid;
	}

	.order-detail-dialog .reason-txt {
		font-size: 12px;
		font-weight: 500;
		color: #666666;
		word-break: break-all;
		line-height: 18px;
		margin: 0 20px 12px;
		padding-bottom: 20px;
	}
	
	.pcover{
		position: absolute;
		top: 65px;
		right: 20px;
	}
	.point_cover{
		width: 40px;
		height: 40px;
		border-radius: 2px;
		object-fit: cover;
	}
	.point_font{
		width: 40px;
		height: 40px;
		border-radius: 2px;
		background: RGBA(230, 237, 254, 1);
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #5084F5;
		box-sizing: border-box;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		word-break: break-all;
		margin: 0 auto;
	}
	
	.hx_btn{
		cursor: pointer;
		float:right;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		margin-right: 16px;
		padding: 0 20px;
		background: #0486FE;
		border-radius: 4px;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 30px;
		height: 30px;
		margin-top: 10px;
	}
</style>
